import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'keys'
})
export class KeysPipe implements PipeTransform {
    transform(value, args:string[]) : any {
        let keys = [];
        for (let key in value) {
          keys.push({key: key, value: value[key]});
        }
        return keys;
    }
}


// WEBPACK FOOTER //
// /Volumes/Projects/WellBrain_Azure_Web/src/app/shared/keys-pipe.ts